export default __webpack_public_path__ + "static/steamTunnel-14e78564fcb2ae11051f7734263eaa60.svg";